export default __webpack_public_path__ + "static/media/option-tag.60158f41.png";